// extracted by mini-css-extract-plugin
export default {"suPlusPayPaymentMethodWrapper":"suPlusPayPaymentMethodWrapper__63TUK","title":"title__KShOQ","suPlusPayLogo":"suPlusPayLogo__5mAbN"};